import React from 'react';
import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import {unpackId} from 'common/diplomatIdUtil';
import {useDispatch} from 'react-redux';
import MoveDialog from 'features/layout/DialogRoutes/dialogs/MoveDialog';
import {transactionsActions} from 'redux/transactions';
import {DialogTypes} from 'common/names';

type Props = {
   data: INav;
   onClose: () => void;
};

const MoveTransactionDialog = ({data, onClose}: Props) => {
   const dispatch = useDispatch();
   const {id} = unpackId(data.id);

   const handleMove = (folderId: string) => {
      dispatch(
         transactionsActions.moveTransaction([id], folderId, {
            onSuccess: onClose,
            onError: onClose,
         })
      );
   };

   return (
      <MoveDialog
         data={data}
         header={DialogTypes.MoveTransactionDialog.dialogName}
         onConfirm={handleMove}
         onClose={onClose}
      />
   );
};

export default MoveTransactionDialog;
